import { Link } from "react-router-dom";
import SectionTitle from "@/components/feature/SectionTitle";
import TopicCard from "@/components/feature/TopicCard";
import { topics } from "@/mocks/topics";
import type { Topic } from "@/types/content";

export default function FeaturedTopics() {
  const featured = (topics as Topic[]).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
        <SectionTitle
          eyebrow="评论区热议"
          title="今天大家都在讨论什么"
          desc="从综艺现场到影视结局，从音乐现场到创作者动态，这些是当前讨论量最高、观点最分裂的话题。"
        />
        <Link
          to="/topics"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full border border-background-300 text-foreground-800 text-sm font-bold whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors shrink-0"
        >
          查看全部话题
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {featured.map((topic) => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>
    </section>
  );
}